module.exports = __webpack_public_path__ + "img/cashier.f58318e0.png";